import React from 'react';
import PropTypes from 'prop-types';
import styles from './ToggleOnOff.scss';
import cx from 'classnames';
import { IconSuccess, IconClose } from '@scotia/canvas-react';

export class ToggleOnOff extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange() {
    this.props.handleChange();
  }

  render() {
    const { toggleIconOn, toggleIconOff, hide, show, crossIcon } = styles;

    return (
      <label className={styles['toogleContainer']}>
        <input
          type="checkbox"
          name="inputCheck"
          checked={this.props.on}
          onChange={this.handleChange}
          disabled={this.props.disabled}
          className={styles['inputCheckbox']}
        />
        <span className={styles['checkmark']}>
          <div className={styles['inputCheckboxButton']}>
            <IconSuccess
              className={cx(toggleIconOn, {
                [toggleIconOff]: !this.props.on,
                [hide]: !this.props.on,
                [show]: this.props.on
              })}
            />
            <IconClose
              className={cx(crossIcon, toggleIconOn, {
                [toggleIconOff]: !this.props.on,
                [hide]: this.props.on,
                [show]: !this.props.on
              })}
            />
          </div>
        </span>
      </label>
    );
  }
}
ToggleOnOff.propTypes = {
  /** Status of the button*/
  on: PropTypes.bool,
  /** Button Disabled*/
  disabled: PropTypes.bool,
  /** A function that triggers when the toggle changes, this function sends to parent component the boolean status of the toggle*/
  handleChange: PropTypes.func.isRequired
};

ToggleOnOff.defaultProps = {
  on: true,
  disabled: false
};
